document.addEventListener('DOMContentLoaded', () => {
  const collectionSwiperEl = document.querySelector('#collectionSwiper');
  const productSwiperEl = document.querySelector('#productSwiper');

  const collectionsData = window.collectionsData || [];

  const renderProducts = (index) => {
    const collection = collectionsData[index];
    if (!collection || !collection.products) return;
    const buttonText = theme.strings.shopNow;
    productSwiperEl.innerHTML = '';
    collection.products.forEach(product => {
      const slide = document.createElement('swiper-slide');
      slide.innerHTML = `
        <a href="${product.url}" aria-label="${product.title}">
          <div class="connected-clean-card">
            <div class="connected-clean-card__image-wrapper">
              <img
                src="${product.image}"
                srcset="${product.image}?width=300 300w, ${product.image}?width=600 600w, ${product.image}?width=900 900w"
                sizes="(max-width: 768px) 300px, (max-width: 1200px) 600px, 900px"
                loading="lazy"
                alt="${product.title}"
                class="connected-clean-card__image"
              />
              ${product.badge ? `<div class="connected-clean-card__badge">${product.badge}</div>` : ''}
            </div>
            <div class="connected-clean-card__content">
              <div class="connected-clean-card__title link-hover-color">${product.title}</div>
              <a href="${product.url}" class="connected-clean-card__button uppercase underline link-hover-color">${buttonText}</a>
            </div>
          </div>
        </a>
      `;

      productSwiperEl.appendChild(slide);
    });
  };

  const initSwipers = () => {
    Promise.all([customElements.whenDefined('swiper-container')]).then(() => {
      renderProducts(collectionSwiperEl.swiper.realIndex || 0);

      const checkSwiper = setInterval(() => {
        if (collectionSwiperEl.swiper) {
          clearInterval(checkSwiper);
          collectionSwiperEl.addEventListener('swiperslidechange', () => {
            renderProducts(collectionSwiperEl.swiper.realIndex);
          });
        }
      }, 100);
    });
  };

  initSwipers();
});
